import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs';

const themeA = require('../../shared/styles/themes/theme-a.scss');
const themeB = require('../../shared/styles/themes/theme-b.scss');
const themeC = require('../../shared/styles/themes/theme-c.scss');
const themeD = require('../../shared/styles/themes/theme-d.scss');
const themeE = require('../../shared/styles/themes/theme-e.scss');
const themeF = require('../../shared/styles/themes/theme-f.scss');
const themeG = require('../../shared/styles/themes/theme-g.scss');
const themeH = require('../../shared/styles/themes/theme-h.scss');

@Injectable()
export class ThemesService {

  public styleTag: any;
  public themeUpdated = new Subject<string>();

  constructor() {
    this.createStyle();
    this.init();
  }

  private init() {
    let theme = localStorage.getItem('theme');
    if (!theme) {
      theme = environment.ui.defaultTheme;
    }


    this.setTheme(theme);
  }

  private createStyle() {
    const head = document.head || document.getElementsByTagName('head')[0];
    this.styleTag = document.createElement('style');
    this.styleTag.type = 'text/css';
    this.styleTag.id = 'appthemes';
    head.appendChild(this.styleTag);
  }

  public setTheme(name: string) {
    localStorage.setItem('theme', name);
    switch (name) {
      case 'A':
        this.injectStylesheet(themeA);
        break;
      case 'B':
        this.injectStylesheet(themeB);
        break;
      case 'C':
        this.injectStylesheet(themeC);
        break;
      case 'D':
        this.injectStylesheet(themeD);
        break;
      case 'E':
        this.injectStylesheet(themeE);
        break;
      case 'F':
        this.injectStylesheet(themeF);
        break;
      case 'G':
        this.injectStylesheet(themeG);
        break;
      case 'H':
        this.injectStylesheet(themeH);
        break;
      default:
        this.injectStylesheet(environment.ui.defaultTheme);
        break;
    }

    this.themeUpdated.next(name);
  }

  public injectStylesheet(css: any) {
    this.styleTag.innerHTML = css.default;
  }

  public getDefaultTheme() {
    let theme = localStorage.getItem('theme');
    if (!theme) {
      theme = environment.ui.defaultTheme;
    }
    return theme;
  }
}
